/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 29/01/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en nueva/guardar
*      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Bloqueo de artículos con Nueva activo
*      4       | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Eliminaciones en submenú de otras acciones
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Tooltip } from "@mui/material";
import RestorePageIcon from '@mui/icons-material/RestorePage';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DirectionsIcon from "@mui/icons-material/Directions";
import VerifiedIcon from "@mui/icons-material/Verified";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from '@mui/icons-material/Print';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';

import { Fragment, useState, useEffect, useRef } from "react";
import { useSesion } from "../../context/System/SesionContext";
import { useInventarios } from "../../context/Inventarios/InventariosContext";
import { useDoubleClickPrevention } from '../../hooks/useDoubleClickPrevention';
import MnuDangerActionsMenu from "../utils/MnuDangerActionsMenu";
import FrmLoginValidate from "../administracion/FrmLoginValidate";

export default function MnuSalidasAlmacenesExhibidoresActions(props) {
    const { onOpenBuscador, onImprimir, onAplicar, onEliminarPartida, onEliminarSalida, buscadorArticulosBloqueado, onRefocusBarcode, accionesBloqueadas, onBuscarSalida, onSalir, onGuardarEdicion, onNueva } = props;
    const { getPermisoBoton, getNombreBoton, getStatusPath } = useSesion();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const [openModalValidarCancelar, setOpenModalValidarCancelar] = useState(false);
    const prevProcessing = useRef(isProcessing);
    useEffect(() => {
      if (prevProcessing.current && !isProcessing) {
        onRefocusBarcode?.();
      }
      prevProcessing.current = isProcessing;
    }, [isProcessing, onRefocusBarcode]);

    const {
        handleClickRegresarMainDashboard,
        handleImprimirSalida,
        handleBuscarArticuloDescripcion,
        handleObtenerDatosSalidas,
        listaSalidas,
        handleAplicarSalida,
        handleCancelarSalida,
        titleActionSave, handleClickNuevaGuardarSalida, handleClickEditarGuardarSalida, handleClickNuevaSalidaButton, statusSalida,
        handleOpenModalBuscarEntradaSalida,
    } = useInventarios();

    const handleRefresh = () => {
        handleObtenerDatosSalidas();
        onRefocusBarcode?.();
    };

    const handleEliminaPartida = () => {
        onEliminarPartida?.();
        onRefocusBarcode?.();
    };

    const handleEliminaSalida = () => {
        onEliminarSalida?.();
        onRefocusBarcode?.();
    };

    const tieneMovimientos =
        Array.isArray(listaSalidas) && listaSalidas.length > 0;

    const statusMovimiento = (statusSalida || "").trim().toUpperCase();
    const movimientoBloqueado =
        statusMovimiento === "TR" || statusMovimiento === "CA";
    const textoBoton = movimientoBloqueado ? "EDITAR" : titleActionSave;
    const puedeNueva = true;
    const puedeEditarGuardar = !movimientoBloqueado && tieneMovimientos;
    const puedeAplicar = tieneMovimientos && !movimientoBloqueado && !accionesBloqueadas;

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={() => executeWithProtection(onSalir || handleClickRegresarMainDashboard)} disabled={isProcessing}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={"NUEVA"}>
                <span>
                    <IconButton onClick={() => executeWithProtection(onNueva || handleClickNuevaSalidaButton)} disabled={isProcessing || !puedeNueva}>
                        <AddIcon className="icon" /><p className="icon">NUEVA</p>
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={textoBoton === "GUARDAR" ? "GUARDAR" : "EDITAR"}>
                <span>
                    <IconButton onClick={() => executeWithProtection(
                        textoBoton === "GUARDAR" ? (onGuardarEdicion || handleClickNuevaGuardarSalida) : handleClickEditarGuardarSalida
                    )} disabled={isProcessing || !puedeEditarGuardar}>
                        {textoBoton === "GUARDAR" ? <SaveIcon className="icon" /> : <EditIcon className="icon" />}
                        <p className="icon">{textoBoton === "NUEVA" ? "EDITAR" : textoBoton}</p>
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={"Aplicar"} disabled={!puedeAplicar}>
                <span>
                    <IconButton onClick={() => executeWithProtection(onAplicar || handleAplicarSalida)} disabled={isProcessing || !puedeAplicar}>
                        <SaveAltIcon className="icon" /><p className="icon">Aplicar</p>
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={"Imprimir"} disabled={!tieneMovimientos}>
                <span>
                    <IconButton onClick={() => executeWithProtection(onImprimir || handleImprimirSalida)} disabled={isProcessing || !tieneMovimientos}>
                        <PrintIcon className="icon" /><p className="icon">Salida</p>
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={"Artículos (Alt+F1)"}>
                <span>
                    <IconButton onClick={() => executeWithProtection(() => onOpenBuscador ? onOpenBuscador() : handleBuscarArticuloDescripcion())} disabled={isProcessing || buscadorArticulosBloqueado || movimientoBloqueado}>
                        <SearchIcon className="icon" /><p className="icon">Artículos</p>
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={"SALIDA"}>
                <IconButton onClick={() => executeWithProtection(onBuscarSalida || handleOpenModalBuscarEntradaSalida)} disabled={isProcessing}>
                    <SearchIcon className="icon" /><p className="icon">Salida</p>
                </IconButton>
            </Tooltip>
            {listaSalidas.length > 0 && statusMovimiento === "TR" ?
                <Tooltip title={"Cancelación y nota de crédito"}>
                    <span>
                        <IconButton onClick={() => executeWithProtection(() => setOpenModalValidarCancelar(true))} disabled={isProcessing}>
                            <RestorePageIcon className="icon" /><p className="icon">Cancelar</p>
                        </IconButton>
                    </span>
                </Tooltip>
                : null
            }
            <FrmLoginValidate
                openModal={openModalValidarCancelar}
                tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                handleComandoEjecucion={async () => { await handleCancelarSalida(); setOpenModalValidarCancelar(false); onRefocusBarcode?.(); }}
                hancleCloseModalValidator={() => setOpenModalValidarCancelar(false)}
            />
            <Tooltip title="Refrescar">
                <IconButton onClick={() => executeWithProtection(handleRefresh)} disabled={isProcessing}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip>
            <MnuDangerActionsMenu
                tooltip="Otras acciones"
                actions={[
                    {
                        label: "Eliminar partida",
                        onClick: handleEliminaPartida,
                        disabled: !tieneMovimientos || movimientoBloqueado || accionesBloqueadas,
                    },
                    {
                        label: "Eliminar salida",
                        onClick: handleEliminaSalida,
                        disabled: !tieneMovimientos || movimientoBloqueado || accionesBloqueadas,
                    },
                ]}
            />
        </Fragment>
    );
}
